// extracted by mini-css-extract-plugin
module.exports = {"root":"TopBar_root__FnNSg","logo":"TopBar_logo__1oJ0B","menu":"TopBar_menu__3i-Uc","user":"TopBar_user__1RAOA"};